import { isVoiceEnabled } from "./focus";
export const replaceLocation = (nav, newLocation) => {
    if (isVoiceEnabled()) {
        nav.navigate(newLocation);
    }
    else {
        window.location.replace(newLocation);
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmF2LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2hlbHBlcnMvbmF2LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFFekMsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLENBQUMsR0FBUSxFQUFFLFdBQW1CLEVBQUUsRUFBRTtJQUM3RCxJQUFJLGNBQWMsRUFBRSxFQUFFO1FBQ2xCLEdBQUcsQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDLENBQUM7S0FDN0I7U0FBTTtRQUNILE1BQU0sQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLFdBQVcsQ0FBQyxDQUFDO0tBQ3hDO0FBQ0wsQ0FBQyxDQUFDIn0=